import { FormSelectDataType, getContactFieldTitle } from '@systemeio/ui'
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const useSmsSubstitutes = () => {
  const { t } = useLocoTranslation()

  const { fields: substitutes } = useContactFields()

  const contactSubstitutionData: FormSelectDataType<string>[] = (substitutes?.items ?? []).map(
    el => ({
      id: `{{${el.slug}}}`,
      caption: getContactFieldTitle(el),
    }),
  )

  const affiliateSubstitutionData: FormSelectDataType<string>[] = [
    { caption: t('dashboard.email.contact_affiliate_id'), id: '{{affiliate_id}}' },
    { caption: t('dashboard.email.contact_affiliate_url'), id: '{{affiliate_dashboard}}' },
  ]

  const substitutionData = [...contactSubstitutionData, ...affiliateSubstitutionData]

  const isReady = !!substitutes

  return {
    substitutionData,
    isReady,
  }
}
